import { Lang, themeColors } from '@/config';
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig';
import { darken, isAllEmpty, lighten } from '@pureadmin/utils';
export const CommonUtils = {
  // src/utils/changeFavicon.ts
  changeFavicon(faviconUrl: string): void {
    // 尝试找已有的 <link rel="icon">
    const existing = document.querySelector("link[rel*='icon']") as HTMLLinkElement | null;
    const link = existing ?? document.createElement('link');

    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconUrl;

    if (!existing) {
      document.head.appendChild(link);
    }
  },
  getItemByLable(data: Array<any>, lable: any) {
    const option = data.find((option) => option.label === lable);
    return option;
  },
  /**
   * 应用主题
   * @param themeColorKey 主题标识，如 'mingQing'
   */ applyTheme(): void {
    const sysStore = useSystemConfigStoreHook();
    // 取后台下发的 theme，回退到第一个 themeColors 的 themeColor
    const key = sysStore.commonConfig.theme ?? themeColors[0].value;
    // data-theme 一定是 string
    document.documentElement.setAttribute('data-theme', key);
    const theme = themeColors.find((tc) => tc.value === key) ?? themeColors[0];
    document.documentElement.style.setProperty('--color-main-primary', theme.color);
    // 设置 Element Plus 的主色变量
    document.documentElement.style.setProperty('--el-color-primary', theme.color);
    for (let i = 1; i <= 2; i++) {
      document.documentElement.style.setProperty(
        `--el-color-primary-dark-${i}`,
        darken(theme.color, i / 10)
      );
    }
    for (let i = 1; i <= 9; i++) {
      document.documentElement.style.setProperty(
        `--el-color-primary-light-${i}`,
        lighten(theme.color, i / 10)
      );
    }
  },
  parseImgUrls(raw: unknown, lang: Lang, fallbackLang: Lang = Lang.LAN_CN): string {
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      // JSON 形式 { zh: "...", en: "..." }
      if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
        try {
          const obj = JSON.parse(trimmed) as Record<string, string>;
          return obj[lang] ?? obj[fallbackLang] ?? '';
        } catch {
          /* ignore */
        }
      }
      // 单一 URL
      return trimmed;
    }
    return '';
  },
  getJSONObj(str: string) {
    if (isAllEmpty(str)) {
      return null;
    }
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  },
  isJsonString(str: string): boolean {
    try {
      CommonUtils.getJSONObj(str);
      return true;
    } catch (e) {
      return false; // 如果解析出错，说明不是有效的JSON数组字符串
    }
  },
  getJSON(str: any) {
    try {
      return JSON.stringify(str);
    } catch (e) {
      console.error('JSON parsing error:', e);
      return str;
    }
  },
  getTranslateText(value: string | Record<string, any>, tLang: Lang) {
    let lang = Lang.LAN_CN;
    if (!isAllEmpty(tLang)) {
      lang = tLang;
    }

    // 如果是对象，直接返回指定语言字段
    if (typeof value === 'object' && value !== null) {
      return value?.[lang] || value?.[Lang.LAN_CN] || Object.values(value)[0] || '';
    }

    // 如果是字符串，尝试解析为 JSON
    if (CommonUtils.isJsonString(value)) {
      try {
        const jsonObj = CommonUtils.getJSONObj(value);
        return jsonObj?.[lang]?.[0] || jsonObj?.[lang] || value;
      } catch (error) {
        console.error('JSON parsing error:', error);
        return value;
      }
    }

    // 普通字符串，直接返回
    return value;
  },
  navigateTo(url: string) {
    if (url.startsWith('http')) {
      window.open(url, '_blank');
    }
  },
};
